import { render, staticRenderFns } from "./PlannerBoard.vue?vue&type=template&id=052f84e3"
import script from "./PlannerBoard.vue?vue&type=script&lang=js"
export * from "./PlannerBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports